import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ko from './locales/ko/translation.json';
import en from './locales/en/translation.json';

// 접속 시 언어는 항상 영어로 고정한다.
// 브라우저 언어 감지와 localStorage 저장을 쓰지 않으므로, 새로고침하면 다시 영어로 시작한다.
// (헤더의 KO/EN 토글은 그대로 동작하며, 해당 세션에서만 유지된다)
i18n
  .use(initReactI18next)
  .init({
    resources: {
      ko: { translation: ko },
      en: { translation: en },
    },
    lng: 'en',
    fallbackLng: 'en',
    supportedLngs: ['ko', 'en'],
    interpolation: {
      escapeValue: false,
    },
  });

// 문서 언어 속성을 현재 언어와 동기화한다.
// 스크린리더 발음, 브라우저 자동번역, 검색엔진 언어 판별이 이 값을 기준으로 동작한다.
const syncDocumentLang = (lng: string): void => {
  document.documentElement.lang = lng;
};

syncDocumentLang(i18n.language);
i18n.on('languageChanged', syncDocumentLang);

export default i18n;
